import forgotpassword from 'api/definitions/forgotpassword';
import { appendClientIdParam } from 'utils/append-client-id-param';
import history from 'utils/history';
import urls from 'constants/urls';

import { postForgotPasswordActionTypes } from './types';

const forgotPasswordAsync = email => ({
  types: postForgotPasswordActionTypes.triplet,
  apiCall: forgotpassword.post({ body: { username: email } }),
  email,
});

export const forgotPassword = values => async dispatch =>
  dispatch(forgotPasswordAsync(values.email)).then(() => {
    history.push(appendClientIdParam(urls.forgotPasswordSuccess));
  });
